import { useQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'
import { VariablesData } from '@/pages/Settings/AutoReply/helpers/types'

const getAutoReplyVariables = async () => {
  const response = await client.get(`/auto_reply_trigger/vars`)
  return response as VariablesData
}

const useGetAutoReplyVariables = () => {
  const { isLoading, error, data } = useQuery({
    queryKey: ['autoreply', 'autoreply_variables'],
    queryFn: getAutoReplyVariables,
    staleTime: 30000,
    refetchOnWindowFocus: false
  })

  return { data, isLoading, error }
}

export default useGetAutoReplyVariables
